export default __webpack_public_path__ + "static/media/AllProductItems9.37634d52.png";